export default __webpack_public_path__ + "static/media/right-front.d41b78f6.png";